import React from 'react'

export const PlaylistPage = () => <h1>Playlist page</h1>
